export enum WorldType {
    PARIS = 'Paris',
    BALI = 'Bali',
    ITALY = 'Italy',
    JAPAN = 'Japan',
    ICELAND = 'Iceland',
    AUSTRALIA = 'Australia',
    EGYPT = 'Egypt',
    ARIZONA = 'Arizona',
    AUSTRIA = 'Austria',
    TANZANIA = 'Tanzania',
    BERLIN = 'Berlin',
    CAMBODIA = 'Cambodia',
    ENGLAND = 'England',
    CANADA = 'Canada',
    BRAZIL = 'Brazil',
    RUSSIA = 'Russia',
    CALIFORNIA = 'California',
    POLAND = 'Poland',
    ARGENTINA = 'Argentina',
    TURKEY = 'Turkey',
    GREECE = 'Greece',
    CUBA = 'Cuba',
    SPAIN = 'Spain',
    KOREA = 'Korea',
    UKRAINE = 'Ukraine',
    CHILE = 'Chile',
    INDIA = 'India',
    FRENCHRIVIERA = 'FrenchRiviera',
    NORWAY = 'Norway',
    NEWZEALAND = 'NewZealand',
    MADAGASCAR = 'Madagascar',
}

export const WORLDS: string[] = Object.values(WorldType);
